import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule, MatDialogModule, MatIconModule, MatProgressSpinnerModule, MatTooltipModule } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { VerificationCodeModule } from '@core/components/verification-code/verification-code.module';
import { VideoInfoModalComponent } from '@core/components/video-info-modal/video-info-modal.component';
import { VideoInfoModalModule } from '@core/components/video-info-modal/video-info-modal.module';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { RedirectAuthenticatedGuard } from '@core/guard/redirect-authenticated.guard';
import { PipesModule } from '@fuse/pipes/pipes.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { ReadRecoveryCodesModule } from '../settings/profile/dialogs/read-recovery-codes-dialog/read-recovery-codes.module';
import { MfaService } from '../settings/profile/services/mfa.service';
import { LoginAuthComponent } from './children/auth/auth.component';
import { EmailStepComponent } from './children/auth/steps/email-step/email-step.component';
import { ExpiringPasswordStepComponent } from './children/auth/steps/expiring-password-step/expiring-password-step.component';
import { MfaStepComponent } from './children/auth/steps/mfa-step/mfa-step.component';
import { PasswordStepComponent } from './children/auth/steps/password-step/password-step.component';
import { RecoveryCodeStepComponent } from './children/auth/steps/recovery-code-step/recovery-code-step.component';
import { LoginRecoverPasswordComponent } from './children/recover-password/recover-password.component';
import { LoginRedirectComponent } from './children/redirect/redirect.component';
import { LoginResetPasswordComponent } from './children/reset-password/reset-password.component';
import { CodeStepComponent } from './children/reset-password/steps/code-step/code-step.component';
import { NewPasswordStepComponent } from './children/reset-password/steps/new-password-step/new-password-step.component';
import { SuccessStepComponent } from './children/reset-password/steps/success-step/success-step.component';
import { LoginComponent } from './login.component';
import { LoginResolver } from './services/login.resolver';

const routes: Routes = [
  {
    path: 'entrar',
    redirectTo: 'login'
  },
  {
    path: 'esqueci-minha-senha',
    redirectTo: 'login/recuperar-senha'
  },
  {
    path: 'redirecionamento-usuario',
    redirectTo: 'login/redirecionando'
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [RedirectAuthenticatedGuard],
    resolve: { loginCustomization: LoginResolver },
    children: [
      {
        path: '',
        component: LoginAuthComponent,
        data: { title: 'CORE.SERVICES.NAVIGATION.TITLES.LOGIN' },
      },
      {
        path: 'redirecionando',
        component: LoginRedirectComponent,
        data: { title: 'CORE.SERVICES.NAVIGATION.TITLES.AUTH_REDIRECT' }
      },
      {
        path: 'recuperar-senha',
        component: LoginRecoverPasswordComponent,
        data: { title: 'CORE.SERVICES.NAVIGATION.TITLES.FORGOT_PASSWORD' },
      },
      {
        path: 'recuperar-senha/:email',
        component: LoginResetPasswordComponent,
        data: { title: 'CORE.SERVICES.NAVIGATION.TITLES.RESET_PASSWORD' },
      }
    ]
  },
];

@NgModule({
  declarations: [
    LoginComponent,
    MfaStepComponent,
    CodeStepComponent,
    LoginAuthComponent,
    EmailStepComponent,
    SuccessStepComponent,
    PasswordStepComponent,
    LoginRedirectComponent,
    NewPasswordStepComponent,
    RecoveryCodeStepComponent,
    LoginResetPasswordComponent,
    ExpiringPasswordStepComponent,
    LoginRecoverPasswordComponent,
  ],
  imports: [
    FormsModule,
    PipesModule,
    CommonModule,
    TranslateModule,
    FuseSharedModule,
    VerificationCodeModule,
    BrowserAnimationsModule,
    RouterModule.forChild(routes),

    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatTooltipModule,
    ReadRecoveryCodesModule,
    MatProgressSpinnerModule,
    VideoInfoModalModule
  ],
  providers: [
    MfaService,
    LoginResolver,
    CustomMessagesService
  ]
})
export class LoginModule { }
